import dynamic from 'next/dynamic';
import { ShareByEmailProps } from './ShareByEmail.types';

export const ShareByEmailMGP = dynamic<ShareByEmailProps>(() => import('./ShareByEmail'));
